// extracted by mini-css-extract-plugin
module.exports = {"helperText":"AdaptiveTextQuestionFormItem_helperText__3Wtfp"};